import type AssistantController from '../controllers/AssistantController';
import Tool, { type IToolActionInput } from './Tool';

type GoActionInput = IToolActionInput & {
  assistantController: AssistantController;
  prompt: string;
  image: File;
};

class ToolAssistantGo extends Tool {
  static toolName = 'Start the AI assistant';

  static async action({ assistantController, prompt, image }: GoActionInput) {
    void assistantController.actionGenerateResponse(prompt, image);
  }

  static enabled() {
    return true;
  }
}

type StopActionInput = IToolActionInput & {
  assistantController: AssistantController;
};

class ToolAssistantStop extends Tool {
  static toolName = 'Stop the AI assistant';

  static async action({ assistantController }: StopActionInput) {
    void assistantController.actionStopGeneration();
  }

  static enabled() {
    return true;
  }
}

export { ToolAssistantGo, ToolAssistantStop };
